(function(global) {
  var PowensWebviewFlow = {
    Connect: 'connect',
    Reconnect: 'reconnect',
    Manage: 'manage',
    Payment: 'payment'
  };

  var PowensWebviewLanguage = {
    English: 'en',
    French: 'fr',
    German: 'de',
    Dutch: 'nl',
    Italian: 'it',
    Spanish: 'es',
    Portuguese: 'pt'
  };

  var powensWebviewOrigin = 'https://webview.powens.com';
  var sectionElementId = 'powens-webview';
  var iframeElementId = 'powens-webview-frame';

  function PowensWebviewElement() {
    return Reflect.construct(HTMLElement, [], PowensWebviewElement);
  }

  PowensWebviewElement.prototype = Object.create(HTMLElement.prototype);
  PowensWebviewElement.prototype.constructor = PowensWebviewElement;

  PowensWebviewElement.observedAttributes = [];

  PowensWebviewElement.prototype.attributeChangedCallback = function(property, oldValue, newValue) {
    if (oldValue === newValue) return;
    this[property] = newValue;
  };

  PowensWebviewElement.prototype.listenMessageEvents = function() {
    window.addEventListener('message', this.messageListener);
  };

  PowensWebviewElement.prototype.unsubscribeMessageEvents = function() {
    window.removeEventListener('message', this.messageListener);
  };

  PowensWebviewElement.prototype.handleWebviewTermination = function(eventData) {
    if (eventData.type !== 'powensWebviewTermination') return;
    this.closeWebview();
    window.postMessage(eventData, window.origin);
  };

  PowensWebviewElement.prototype.buildWebviewUrl = function() {
    var flow = this.options.flow || 'connect';
    var langPath = this.options.lang ? '/' + this.options.lang : '';
    this.url = new URL(powensWebviewOrigin + langPath + '/' + flow);

    if (!this.options) return;

    Object.keys(this.options).forEach(function(key) {
      if (
        this.options[key] === undefined ||
        ['flow', 'lang', 'connectorFieldValues'].includes(key)
      ) return;

      var paramName = key.replace(/[\w]([A-Z])/g, function(s) {
        return s[0] + '_' + s[1];
      }).toLowerCase();

      this.url.searchParams.append(paramName, this.options[key]);
    }, this);

    if (!this.options.connectorFieldValues) return;

    var uuids = Object.keys(this.options.connectorFieldValues);
    if (uuids.length) {
      uuids.forEach(function(uuid) {
        var fieldNames = Object.keys(this.options.connectorFieldValues[uuid]);
        fieldNames.forEach(function(fieldName) {
          this.url.searchParams.append(
            uuid + '.' + fieldName,
            this.options.connectorFieldValues[uuid][fieldName]
          );
        }, this);
      }, this);
    }
  };

  PowensWebviewElement.prototype.openWebview = function() {
    if (this.shadowRoot && this.shadowRoot.getElementById(sectionElementId)) return;
    this.buildWebviewUrl();

    var sectionElement = document.createElement('section');
    sectionElement.id = sectionElementId;
    this.shadowRoot.appendChild(sectionElement);

    var iframeElement = document.createElement('iframe');
    iframeElement.id = iframeElementId;
    iframeElement.loading = 'lazy';
    iframeElement.src = this.url.href;
    sectionElement.appendChild(iframeElement);

    this.listenMessageEvents();
  };

  PowensWebviewElement.prototype.closeWebview = function() {
    this.unsubscribeMessageEvents();
    if (this.shadowRoot) {
      var section = this.shadowRoot.getElementById(sectionElementId);
      if (section) section.remove();
    }
  };

  PowensWebviewElement.prototype.connectedCallback = function() {
    var self = this;

    this.messageListener = function(event) {
      if (!self.url || event.origin !== self.url.origin) return;
      self.handleWebviewTermination(event.data);
    };

    var shadow = this.attachShadow({ mode: 'open' });
    var xPadding = '20px';

    shadow.innerHTML = `
      <style>
        #${sectionElementId} {
          display: flex;
          position: fixed;
          top: 0;
          left: 0;
          width: calc(100% - ${xPadding} * 2);
          height: 100%;
          padding: 0 ${xPadding};
          justify-content: center;
          background-color: rgba(0, 0, 0, .33);
        }

        #${iframeElementId} {
          width: 440px;
          height: 90vh;
          max-height: 740px;
          margin: auto;
          border: none;
          border-radius: 12px;
          box-shadow: 0 0 32px 0px rgba(0, 0, 0, .5);
        }
      </style>
    `;
  };

  customElements.define('powens-webview', PowensWebviewElement);

  // Expose enums globally for usage
  global.PowensWebviewFlow = PowensWebviewFlow;
  global.PowensWebviewLanguage = PowensWebviewLanguage;
})(window);
